import { render } from "./ApplicationModernization.vue?vue&type=template&id=68fab842&scoped=true&ts=true"
import script from "./ApplicationModernization.vue?vue&type=script&lang=ts"
export * from "./ApplicationModernization.vue?vue&type=script&lang=ts"

import "./ApplicationModernization.vue?vue&type=style&index=0&id=68fab842&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68fab842"]])

export default __exports__